var map = {
	"./codesports.svg": "sd/s",
	"./logo-carlton.svg": "HWsO",
	"./logo-collingwood.svg": "6njn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KZtR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.svg$
// module id = KZtR
// module chunks = 1